import block from 'bem-cn-lite';
import {FC, useContext} from 'react';
import {Icon, Text} from '@gravity-ui/uikit';
import {ArrowLeft, Envelope, Handset} from '@gravity-ui/icons';
import {AppContext} from '@app/context';
import {TooltipCopy} from '@components/TooltipCopy';
import Whatsapp from '@assets/whatsapp-icon.svg';

import './ContactsScreen.scss';

const b = block('contacts-screen-main-header');

interface ContactsScreenProps {
    isOpen: boolean;
    onBack: () => void;
}

export const ContactsScreen: FC<ContactsScreenProps> = ({isOpen, onBack}) => {
    const {
        state: {clientDetails}
    } = useContext(AppContext);

    return (
        <div className={b({open: isOpen})}>
            <div className={b('title')}>
                <ArrowLeft onClick={onBack} width={20} height={20} />
                <Text variant="header-2">Контакты</Text>
            </div>

            <div className={b('content')}>
                {clientDetails?.mop && Object.keys(clientDetails.mop).length > 0 ? (
                    <div className={b('manager')}>
                        <Text variant="subheader-2">Ваш менеджер:</Text>
                        <Text variant="body-2">{clientDetails.mop.name || ''}</Text>
                        <TooltipCopy copyText={clientDetails.mop.email || ''}>
                            <Icon data={Envelope} />
                            <Text variant="body-1">{clientDetails.mop.email || ''}</Text>
                        </TooltipCopy>
                        <div className={b('contact-number')}>
                            <a
                                href={`tel:${clientDetails.mop.phone || ''}`}
                                className={b('contact-number-item')}
                            >
                                <Icon data={Handset} />
                                <Text variant="body-1">{clientDetails.mop.phone || ''}</Text>
                            </a>
                            <a
                                href={`https://web.whatsapp.com/send?phone=${clientDetails.mop.phone || ''}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={b('link')}
                            >
                                <img src={Whatsapp} alt="Whatsapp" />
                            </a>
                        </div>
                    </div>
                ) : null}

                <div className={b('divider')}></div>

                {clientDetails?.mrk && Object.keys(clientDetails.mrk).length > 0 ? (
                    <div className={b('bottom-block')}>
                        <Text variant="subheader-2" className={b('bottom-block-title')}>
                            Специалист клиентской поддержки:
                        </Text>

                        <div className={b('manager')}>
                            <Text variant="body-2">{clientDetails.mrk.name || ''}</Text>
                            <TooltipCopy copyText={clientDetails.mrk.email || ''}>
                                <Icon data={Envelope} />
                                <Text variant="body-1">{clientDetails.mrk.email || ''}</Text>
                            </TooltipCopy>
                            <div className={b('contact-number')}>
                                <a
                                    href={`tel:${clientDetails.mrk.phone || ''}`}
                                    className={b('contact-number-item')}
                                >
                                    <Icon data={Handset} />
                                    <Text variant="body-1">{clientDetails.mrk.phone || ''}</Text>
                                </a>
                                <a
                                    href={`https://web.whatsapp.com/send?phone=${clientDetails.mrk.phone || ''}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={b('link')}
                                >
                                    <img src={Whatsapp} alt="Whatsapp" />
                                </a>
                            </div>
                        </div>
                    </div>
                ) : null}

                {clientDetails?.rop && Object.keys(clientDetails.rop).length > 0 ? (
                    <div className={b('bottom-block')}>
                        <Text variant="subheader-2" className={b('bottom-block-title')}>
                            Руководитель отдела продаж:
                        </Text>

                        <div className={b('manager')}>
                            <Text variant="body-2">{clientDetails.rop.name || ''}</Text>
                            <TooltipCopy copyText={clientDetails.rop.email || ''}>
                                <Icon data={Envelope} />
                                <Text variant="body-1">{clientDetails.rop.email || ''}</Text>
                            </TooltipCopy>
                            <div className={b('contact-number')}>
                                <a
                                    href={`tel:${clientDetails.rop.phone || ''}`}
                                    className={b('contact-number-item')}
                                >
                                    <Icon data={Handset} />
                                    <Text variant="body-1">{clientDetails.rop.phone || ''}</Text>
                                </a>
                                <a
                                    href={`https://web.whatsapp.com/send?phone=${clientDetails.rop.phone || ''}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={b('link')}
                                >
                                    <img src={Whatsapp} alt="Whatsapp" />
                                </a>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};
